import React from "react";
import PropTypes from "prop-types";
import formatId from "lib/formatId";
import classnames from "classnames";

export default class Column extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }


    handleClick() {
        const {onSort, column} = this.props;
        onSort && onSort(column);
    }

    render() {
        const {
            column: {
                key,
            },
            sorts,
            name,
            onSort,
        } = this.props;
        return (
            <th
                id={formatId(key, "header-item")}
                onClick={this.handleClick}
                data-key={key}
                className={classnames(sorts[key], {
                    sortable: !!onSort,
                })}
            >
                {name}<span></span>
            </th>
        );
    }
}

Column.propTypes = {
    fixedHeaders: PropTypes.bool,
    column: PropTypes.shape({
        key: PropTypes.string.isRequired,
    }).isRequired,
    sorts: PropTypes.object.isRequired,
    name: PropTypes.string,
    onSort: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/lib/common/selectiontable/lib/header/Column.js